export enum EditUserDataStep {
  EnterNewData = 1,
  EnterVerificationCode = 2,
  ConfirmDataChange = 3
};
